function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import messages from 'modules/PatientResults/messages';
import styles from './TimeInRanges.pcss';
var _React_PureComponent;
class TimeInRangesChart extends (_React_PureComponent = React.PureComponent) {
    renderNameLabel(timeInRange) {
        if (this.props.isCgmView) {
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    timeInRange.range,
                    " ",
                    this.props.conversion.unitSymbol
                ]
            });
        }
        return messages.labels[timeInRange.name] && /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels[timeInRange.name]));
    }
    renderTimeLabel(minutes) {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                !!Math.floor(minutes / 60) && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        Math.floor(minutes / 60),
                        this.isCgmView ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.hours)) : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.h))
                    ]
                }),
                " ",
                !!(minutes % 60) && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        Math.round(minutes % 60),
                        this.isCgmView ? /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.minutes)) : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.min))
                    ]
                })
            ]
        });
    }
    render() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.timeInRangesChart,
            children: /*#__PURE__*/ _jsxs("div", {
                className: "wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "nameLegend",
                        children: this.props.timeInRanges.map((timeInRange)=>/*#__PURE__*/ _jsxs("div", {
                                className: "nameLegend__section",
                                style: {
                                    height: `${timeInRange.percent || 0}%`
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "nameLegend__sectionLabels",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "nameLegend__sectionLabelName",
                                                children: this.renderNameLabel(timeInRange)
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "nameLegend__sectionLabelRange",
                                                children: this.props.isCgmView ? this.renderTimeLabel(timeInRange.minutes) : /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        timeInRange.range,
                                                        " ",
                                                        this.props.conversion.unitSymbol
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "nameLegend__divider"
                                    })
                                ]
                            }, timeInRange.name))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "barChart",
                        children: this.props.timeInRanges.map((timeInRange)=>/*#__PURE__*/ _jsx("div", {
                                className: cn('barChart__section', `barChart__section--${timeInRange.name}`, {
                                    'barChart__section--transparent': !timeInRange.percent
                                }),
                                style: {
                                    height: `${timeInRange.percent || 0}%`
                                }
                            }, timeInRange.name))
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "percentLegend",
                        children: this.props.timeInRanges.map((timeInRange)=>/*#__PURE__*/ _jsxs("div", {
                                className: "percentLegend__section",
                                style: {
                                    height: `${timeInRange.percent || 0}%`
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "percentLegend__sectionPercentValue",
                                        children: timeInRange.percent ? `${timeInRange.percent}%` : ''
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "percentLegend__sectionPercentTime",
                                        children: !this.props.isCgmView && this.renderTimeLabel(timeInRange.minutes)
                                    })
                                ]
                            }, timeInRange.name))
                    })
                ]
            })
        });
    }
}
_define_property(TimeInRangesChart, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    timeInRanges: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        minutes: PropTypes.number.isRequired,
        percent: PropTypes.number.isRequired,
        range: PropTypes.string.isRequired
    })),
    isCgmView: PropTypes.bool
});
export default withStyles(styles)(TimeInRangesChart);
